import { useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import type ResourceType from '@/presentation/pages/plants/widgets/ResourceType.ts';

export interface SearchCart {
  complex: boolean;
  simpleParams: Record<string, unknown> | null;
  complexParams: Record<string, unknown> | null;
  resourceTypeName: ResourceType | null;
}

export const useSearchCartStore = defineStore('searchCart', () => {
  const searchCart = useLocalStorage<SearchCart>('search_cart', {
    complex: false,
    simpleParams: { page: 1, query: '' },
    complexParams: null,
    resourceTypeName: null,
  });

  function setSimpleSearchCart(simpleParams: Record<string, unknown>): void {
    searchCart.value = {
      complex: false,
      simpleParams,
      complexParams: null,
      resourceTypeName: null,
    };
  }

  function setComplexSearchCart(params: {
    complexParams: Record<string, unknown>;
    resourceTypeName: ResourceType;
  }): void {
    searchCart.value = {
      complex: true,
      simpleParams: null,
      complexParams: params.complexParams,
      resourceTypeName: params.resourceTypeName,
    };
  }

  return { searchCart, setSimpleSearchCart, setComplexSearchCart };
});
